import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import '../Customer/Customer.css';

const UserCreate = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        const generatedUserName = `${firstName.toLowerCase()}_${lastName.toLowerCase()}`;
        const limitedUserName = generatedUserName.slice(0, 15);
        setUserName(limitedUserName);
    }, [firstName, lastName]);

    const clearForm = () => {
        setFirstName('');
        setLastName('');
        setUserName('');
        setContactNumber('');
        setEmail('');
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrorMessage('');

        if (!firstName) {
            setErrorMessage('First Name is required!');
            setIsLoading(false);
            return;
        }

        if (!lastName) {
            setErrorMessage('Last Name is required!');
            setIsLoading(false);
            return;
        }

        if (!contactNumber) {
            setErrorMessage('Contact Number is required!');
            setIsLoading(false);
            return;
        }

        if (!email) {
            setErrorMessage('Email is required!');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            FirstName: firstName,
            LastName: lastName,
            UserName: userName,
            Email: email,
            ContactNumber: contactNumber,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('UserApi', CreateData, token)
            .then((response) => {
                console.log('User Created success:', response);
                setSuccessMessage('User created successfully!');
                setErrorMessage('');
                clearForm();
                history.push('/UserIndex');
            })
            .catch((error) => {
                console.error('User Create error:', error);
                setErrorMessage('Failed to create user.');
                setIsLoading(false);
            });
    };

    return (
        <div className="form-container">
            <div className="form-card">
                {/* Header */}
                <div className="form-header">
                    <h1 className="form-title">Create User</h1>
                    <div className="form-actions">
                        <Link to="/UserIndex" className="btn-back">
                            <ArrowBackIcon fontSize="small" />
                            Back to List
                        </Link>
                        <button className="btn-save" onClick={submitData} disabled={isLoading}>
                            {isLoading ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                <>
                                    <SaveIcon fontSize="small" />
                                    Save
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {/* Messages */}
                {errorMessage && <div className="message error">{errorMessage}</div>}
                {successMessage && <div className="message success">{successMessage}</div>}

                {/* Form Body */}
                <div className="form-body">
                    {/* Row 1 - Names */}
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">First Name *</label>
                            <input
                                className="form-input"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                type="text"
                                placeholder="Enter First Name"
                                maxLength={30}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Last Name *</label>
                            <input
                                className="form-input"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                type="text"
                                placeholder="Enter Last Name"
                                maxLength={30}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">User Name</label>
                            <input
                                className="form-input"
                                value={userName}
                                type="text"
                                placeholder="Auto-generated"
                                readOnly
                                style={{ backgroundColor: '#f8fafc' }}
                            />
                        </div>
                    </div>

                    {/* Row 2 - Contact */}
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">Contact Number *</label>
                            <input
                                className="form-input"
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text"
                                placeholder="Enter Contact Number"
                                maxLength={15}
                            />
                        </div>
                        <div className="form-group" style={{ flex: 2 }}>
                            <label className="form-label">Email *</label>
                            <input
                                className="form-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                placeholder="Enter Email"
                                maxLength={40}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserCreate;
